// extracted by mini-css-extract-plugin
export default {"header":"Header_header__bWhvy","overlay":"Header_overlay__g5JDc"};